import { render, staticRenderFns } from "./LearningmaterialListEntry.vue?vue&type=template&id=15ef10fe&scoped=true"
import script from "./LearningmaterialListEntry.vue?vue&type=script&lang=js"
export * from "./LearningmaterialListEntry.vue?vue&type=script&lang=js"
import style0 from "./LearningmaterialListEntry.vue?vue&type=style&index=0&id=15ef10fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef10fe",
  null
  
)

export default component.exports